import React from 'react';
import Header from '../components/Header';

const ErrorPage = ({ errorMessage }) => {
  console.log(errorMessage);
    return (
      <div>
        {/* <Header /> */}
        <div style={errorContainerStyle}>
          <div style={errorBoxStyle}>
            <h1 style={errorHeadingStyle}>Something Went Wrong</h1>
            {errorMessage && <p style={errorMessageStyle}>Please Contact Support With This Error Code : <span style={errorMessageSpanStyle}>{JSON.stringify(errorMessage)}</span></p>}
          </div>
        </div>
      </div>
    );
  };
  
  const errorContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100vh)', // Adjusted for the header height
    backgroundColor: '#FFEBEE', // Reddish tone background color
  };
  
  const errorBoxStyle = {
    border: '1px solid #D32F2F', // Red color border
    borderRadius: '10px', // Border radius for a card-like appearance
    padding: '20px', // Padding inside the box
    backgroundColor: 'white', // Background color of the box
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Box shadow for a slight elevation
    textAlign: 'center',
  };
  
  const errorHeadingStyle = {
    color: '#D32F2F', // Red color for the heading
    marginBottom: '20px',
    fontWeight: 900
  };
  
  const errorMessageStyle = {
    color: '#2d2d2d', // Darker red color for the error message
    fontSize: '1rem'
  };

  const errorMessageSpanStyle = {
    color: '#C62828', // Darker red color for the error message
    fontWeight: 900,    
  }
  
  export default ErrorPage;
